import { IPreviewSamplePayload } from '@/types/request/illustrationTheme';
import { notificationMessage, NOTIFY_STATUS } from '@/utils';
import { Button, Collapse, Form, Input, InputNumber } from 'antd';
import { useState } from 'react';
import {
  DEFAULT_PREVIEW_SAMPLE,
  loadPreviewSample,
  resetPreviewSample,
  savePreviewSample,
} from '../previewSample';

const { TextArea } = Input;

// リスト共通のテスト生成サンプル設定。localStorage に保存し、各テーマの「テスト生成」で利用される。
export const PreviewSamplePanel: React.FC = () => {
  const [sample, setSample] =
    useState<Required<IPreviewSamplePayload>>(loadPreviewSample);

  const updateField = (
    key: keyof IPreviewSamplePayload,
    value: string | number | null,
  ) => {
    const next = { ...sample, [key]: value ?? '' } as Required<IPreviewSamplePayload>;
    setSample(next);
    savePreviewSample(next);
  };

  const handleReset = () => {
    resetPreviewSample();
    setSample(DEFAULT_PREVIEW_SAMPLE);
    notificationMessage({
      message: 'サンプル値を初期値に戻しました。',
      type: NOTIFY_STATUS.SUCCESS,
    });
  };

  return (
    <Collapse
      items={[
        {
          key: 'preview-sample',
          label: 'テスト生成のサンプル値（共通設定）',
          children: (
            <>
              <p className='text-xs text-gray-500 mb-3'>
                ※ 各テーマの「この画風でテスト生成」で、プロンプト内のテンプレ変数（{'{{diary}}'} など）に差し込まれる値です。この端末に保存されます。
              </p>
              <Form layout='vertical'>
                <Form.Item label='日記本文（diary）'>
                  <TextArea
                    rows={3}
                    value={sample.diary}
                    onChange={(e) => updateField('diary', e.target.value)}
                  />
                </Form.Item>
                <div className='grid grid-cols-2 gap-x-4'>
                  <Form.Item label='年齢（age）'>
                    <InputNumber
                      min={0}
                      className='w-full'
                      value={sample.age}
                      onChange={(v) => updateField('age', v)}
                    />
                  </Form.Item>
                  <Form.Item label='性別（gender）'>
                    <Input
                      value={sample.gender}
                      onChange={(e) => updateField('gender', e.target.value)}
                    />
                  </Form.Item>
                  <Form.Item label='日付（time / YYYY-MM-DD）'>
                    <Input
                      value={sample.time}
                      onChange={(e) => updateField('time', e.target.value)}
                    />
                  </Form.Item>
                  <Form.Item label='感情（emotions）'>
                    <Input
                      value={sample.emotions}
                      onChange={(e) => updateField('emotions', e.target.value)}
                    />
                  </Form.Item>
                  <Form.Item label='家族人数（numberOfFamilyMembers）'>
                    <InputNumber
                      min={1}
                      className='w-full'
                      value={sample.numberOfFamilyMembers}
                      onChange={(v) => updateField('numberOfFamilyMembers', v)}
                    />
                  </Form.Item>
                </div>
                <Button onClick={handleReset}>初期値に戻す</Button>
              </Form>
            </>
          ),
        },
      ]}
    />
  );
};
